/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';
import type { warehouseConnectionConfig } from '../models/warehouseConnectionConfig';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WarehouseConnectionConfigsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count warehouseConnectionConfigs
   * Count warehouseConnectionConfigs (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of warehouseConnectionConfig documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsWarehouseConnectionConfigsCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/warehouseConnectionConfigs/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one warehouseConnectionConfig
   * Find one warehouseConnectionConfig by its unique identifier.
   * @param identifier warehouseConnectionConfig unique identifier
   * @returns any One warehouseConnectionConfig document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsWarehouseConnectionConfigs(
    identifier: string,
  ): CancelablePromise<{
    data?: warehouseConnectionConfig;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/warehouseConnectionConfigs/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace one warehouseConnectionConfig which exists or not
   * Replace one warehouseConnectionConfig which exists or not
   * @param identifier warehouseConnectionConfig unique identifier
   * @param requestBody
   * @returns any warehouseConnectionConfig replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsWarehouseConnectionConfigs(
    identifier: string,
    requestBody?: warehouseConnectionConfig,
  ): CancelablePromise<{
    data?: warehouseConnectionConfig;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/warehouseConnectionConfigs/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing warehouseConnectionConfig
   * Partially update one existing warehouseConnectionConfig
   * @param identifier warehouseConnectionConfig unique identifier
   * @param requestBody
   * @returns any updated warehouseConnectionConfig. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsWarehouseConnectionConfigs(
    identifier: string,
    requestBody?: warehouseConnectionConfig,
  ): CancelablePromise<{
    data?: warehouseConnectionConfig;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/warehouseConnectionConfigs/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one warehouseConnectionConfig
   * Delete one warehouseConnectionConfig
   * @param identifier warehouseConnectionConfig unique identifier
   * @returns any delete status warehouseConnectionConfigs. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsWarehouseConnectionConfigs(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/warehouseConnectionConfigs/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many warehouseConnectionConfigs
   * Find many warehouseConnectionConfigs (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many warehouseConnectionConfig documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsWarehouseConnectionConfigs1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<warehouseConnectionConfig>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/warehouseConnectionConfigs',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple warehouseConnectionConfigs
   * Create one or multiple warehouseConnectionConfigs
   * @param requestBody
   * @returns any One or many warehouseConnectionConfig documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServiceorganizationsWarehouseConnectionConfigs(
    requestBody?: (warehouseConnectionConfig | Array<warehouseConnectionConfig>),
  ): CancelablePromise<{
    data?: (warehouseConnectionConfig | Array<warehouseConnectionConfig>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/warehouseConnectionConfigs',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace many warehouseConnectionConfigs which exists or not
   * Replace many warehouseConnectionConfigs which exists or not
   * @param requestBody
   * @returns any warehouseConnectionConfigs replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsWarehouseConnectionConfigs1(
    requestBody?: Array<warehouseConnectionConfig>,
  ): CancelablePromise<{
    data?: Array<warehouseConnectionConfig>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/warehouseConnectionConfigs',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing warehouseConnectionConfig
   * Partially update many existing warehouseConnectionConfig
   * @param requestBody
   * @returns any warehouseConnectionConfigs updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsWarehouseConnectionConfigs1(
    requestBody?: Array<warehouseConnectionConfig>,
  ): CancelablePromise<{
    data?: Array<warehouseConnectionConfig>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/warehouseConnectionConfigs',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many warehouseConnectionConfigs
   * Delete many warehouseConnectionConfigs using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status warehouseConnectionConfigs. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsWarehouseConnectionConfigs1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/warehouseConnectionConfigs',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
